import {AfterViewInit, Component, Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import ymaps from 'ymaps';
import {NotifierService} from '@services/notifier.service';
import {AppService} from '../../app.service';
import {AppHelper} from '../../core/app.helper';

@Component({
    selector: 'app-map-dialog',
    templateUrl: './map-dialog.component.html',
    styleUrls: ['./map-dialog.component.css']
})
export class MapDialogComponent implements AfterViewInit {
    /**
     * Выбранный язык
     */
    currentLang = null;
    /**
     * Текущие координаты
     */
    currentCoordinates: any = [47.203681, 39.777140];
    /**
     * Найденный объект
     */
    searchObject: any = null;

    /**
     * Конструктор
     * @param appService сервис взаимодействия с внешними ресурсами
     * @param notifier сервис всплывающих сообщений
     * @param dialogRef ссылка на диалог
     * @param data данные для диалога
     */
    constructor(
        public appService: AppService,
        public notifier: NotifierService,
        public dialogRef: MatDialogRef<MapDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string;
            data: any;
        }) {
        if (this.appService?.settings?.map_center_wgs && this.appService.settings.map_center_wgs[0] && this.appService.settings.map_center_wgs[1]) {
            this.currentCoordinates = [this.appService.settings.map_center_wgs[1], this.appService.settings.map_center_wgs[0]];
        }
        this.currentLang = AppHelper.getCurrentLanguage(this.appService);
        if (this.data.data.coordinates) {
            this.currentCoordinates = this.data.data.coordinates;
        }
    }

    /**
     * Событие после завершения инициализации вьюшки
     */
    ngAfterViewInit() {
        ymaps.load('https://api-maps.yandex.ru/2.1/?apikey=' + this.appService?.settings?.geocode_api_key + '&lang=' + (
            this.currentLang && this.currentLang.code ? this.currentLang.code : 'en_US'
        )).then(maps => {
            const map = new maps.Map('map-container', {
                center: this.currentCoordinates,
                zoom: 7,
                controls: ['zoomControl', 'typeSelector']
            });
            let mySearchControl = new maps.control.SearchControl({
                options: {
                    noPlacemark: true
                }
            });
            // Результаты поиска будем помещать в коллекцию.
            let mySearchResults = new maps.GeoObjectCollection(null, {
                hintContentLayout: maps.templateLayoutFactory.createClass('$[properties.name]')
            });
            map.controls.add(mySearchControl);
            map.geoObjects.add(mySearchResults);
            // Выбранный результат помещаем в коллекцию.
            mySearchControl.events.add('resultselect', (e) => {
                let index = e.get('index');
                mySearchControl.getResult(index).then((res) => {
                    mySearchResults.add(res);
                    this.searchObject = res;
                    this.currentCoordinates = res.geometry.getCoordinates();
                });
            }).add('submit', function() {
                mySearchResults.removeAll();
            });
            map.events.add('click', (e) => {
                // Получение координат щелчка
                let coords = e.get('coords');
                maps.geocode(coords).then(res => {
                    let firstGeoObject = res.geoObjects.get(0);
                    mySearchResults.removeAll();
                    mySearchResults.add(firstGeoObject);
                    this.searchObject = firstGeoObject;
                    this.currentCoordinates = coords;
                });
            });
            maps.geocode(this.currentCoordinates).then(res => {
                let firstGeoObject = res.geoObjects.get(0);
                mySearchResults.removeAll();
                mySearchResults.add(firstGeoObject);
                this.searchObject = firstGeoObject;
            });
        }).catch(() => {
            this.notifier.notify('error', this.appService.language_dictionary.system_no_connection_with_system);
        });
    }

    /**
     * Сохранение данных
     */
    save() {
        this.dialogRef.close({
            save: true,
            data: {
                address: this.searchObject?.getAddressLine(),
                coordinates: this.searchObject?.geometry?.getCoordinates()
            }
        });
    }

    /**
     * закрытие диалога
     */
    close() {
        this.dialogRef.close({save: false});
    }
}
